import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'

// Containers
import Full from '@/containers/Full'

// Views
import Home from '@/views/Home'

// Dimensions
import Go from '@/views/Go'

// Editor
import Editor from '@/views/Editor/Editor'

// Usuarios
import ListadoUsuarios from '@/views/Usuario/Listar'
import CrearUsuario from '@/views/Usuario/Crear'
import EditarUsuario from '@/views/Usuario/Editar'
import Perfil from '@/views/Usuario/Perfil'
import Registro from '@/views/Usuario/Registro'
import VerificarCuenta from '@/views/Usuario/VerificarCuenta'
import RecuperarClave from '@/views/Usuario/RecuperarClave'
import AsignarClave from '@/views/Usuario/AsignarClave'

// Cominidad
import ListadoAmigos from '@/views/Comunidad/Amigo/Listar'

import session from '@/js/session.js'
import ENV from 'ENV'

Vue.use(Router)
Vue.use(VueResource)

Vue.http.options.root = ENV.server_back

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      // redirect: '/go/test',
      redirect: 'inicio',
      name: 'home',
      meta: {
        label: 'Inicio'
      },
      component: Full,
      children: [
        {
          path: 'inicio',
          name: 'inicio',
          meta: {
            label: ' ',
            getSessionChat: true
          },
          component: Home
        },
        {
          path: 'usuarios',
          name: 'gestion-usuarios-usuarios',
          meta: {
            label: 'Usuarios'
          },
          redirect: 'usuarios/listado',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listado',
              name: 'gestion-usuarios-listado-usuarios',
              meta: {
                label: 'Listado',
                getSessionChat: true
              },
              component: ListadoUsuarios
            },
            {
              path: 'crear',
              name: 'gestion-usuarios-crear-usuario',
              meta: {
                label: 'Creación',
                getSessionChat: true
              },
              component: CrearUsuario
            },
            {
              path: 'editar',
              name: 'gestion-usuarios-editar-usuario',
              meta: {
                label: 'Edición',
                getSessionChat: true
              },
              component: EditarUsuario
            }
          ]
        },
        {
          path: 'usuario',
          name: 'usuario',
          meta: {
            label: 'Usuario'
          },
          redirect: 'usuario/registro',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'registro',
              name: 'usuario-registro',
              meta: {
                label: 'Registro',
                getSessionChat: true
              },
              component: Registro
            },
            {
              path: 'perfil',
              name: 'usuario-perfil',
              meta: {
                label: 'Perfil',
                getSessionChat: true
              },
              component: Perfil
            },
            {
              path: 'verificar-cuenta/:token_verificacion',
              name: 'usuario-verificar-cuenta',
              meta: {
                label: 'Verificar cuenta de usuario'
              },
              component: VerificarCuenta
            },
            {
              path: 'recuperar-clave',
              name: 'usuario-recuperar-clave',
              meta: {
                label: 'Recuperar clave de acceso'
              },
              component: RecuperarClave
            },
            {
              path: 'asignar-clave/:correo_electronico/:token_verificacion',
              name: 'usuario-asignar-clave',
              meta: {
                label: 'Asignar nueva clave de acceso'
              },
              component: AsignarClave
            }
          ]
        },
        {
          path: 'comunidad',
          name: 'gestion-comunidad',
          meta: {
            label: 'Comunidad'
          },
          redirect: 'comunidad/amigos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'amigos',
              name: 'gestion-comunidad-listado-amigos',
              meta: {
                label: 'Amigos',
                getSessionChat: true
              },
              component: ListadoAmigos
            }
          ]
        },
        {
          path: 'editor',
          name: 'editor',
          meta: {
            label: 'Módulo Editor',
            getSessionChat: true
          },
          component: Editor
        },
        {
          path: 'go/:dimension',
          name: 'go',
          meta: {
            label: 'Dimension',
            getSessionChat: true
          },
          component: Go
        }
      ]
    }
  ]
})

router.afterEach((to, from) => {
  if (to.meta.getSessionChat) {
    session.loginChat()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js